import React, { useMemo, useState } from 'react';
import { translate } from '../../Services/translation';
import Icon from '../Icon';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { toggleDesktopFilterBar } from '../../Actions/ProductFiltering.action';
import FilterMenu from './FilterMenu';

const FilterTriggerButton = () => {
  const dispatch = useDispatch();
  const { showDesktopFilters = false, filters = [] } = useTypedSelector(
    (state) => state.productFiltering
  );
  type CurrentMenuType = 'filtersAndSorting';
  const [currentMenu, setCurrentMenu] = useState<
    CurrentMenuType | undefined
  >();

  const totalActiveFilters = useMemo(
    () =>
      filters?.length > 0
        ? filters.reduce(
            (sum, filter) => sum + filter.selectedOptions.length,
            0
          )
        : 0,
    [filters]
  );
  return (
    <>
      <button
        className="hidden items-center lg:flex "
        onClick={() =>
          dispatch(toggleDesktopFilterBar(!showDesktopFilters))
        }
      >
        <Icon
          className="mr-2 h-5 w-5 text-gray-700"
          name="sliders-light"
        />
        <span className="text-sm uppercase">
          {translate('category.filter')}
        </span>
        {totalActiveFilters >= 1 && (
          <span className="ml-1 flex h-5 w-5 items-center justify-center rounded-full bg-gray-700">
            <span className="text-sm leading-tight text-white">
              {totalActiveFilters}
            </span>
          </span>
        )}
      </button>
      <button
        className="flex py-2 lg:hidden"
        onClick={() => setCurrentMenu('filtersAndSorting')}
      >
        <Icon
          className="mr-2 block h-5 w-5 text-gray-700"
          name="sliders-light"
        />
        <span className="text-sm uppercase">
          {translate('category.filter-and-sorting')}
        </span>
      </button>
      <FilterMenu
        totalActiveFilters={totalActiveFilters}
        currentMenu={currentMenu}
        setCurrentMenu={setCurrentMenu}
      />
    </>
  );
};

export default FilterTriggerButton;
